import callApi from './callApi';

export const enableOrgAI = (organizationId, isAiEnabled) => {
  const url = 'ai-config/enable';
  const headers = { 'x-organization-id': organizationId };
  return callApi(url, headers, 'PUT', { isAiEnabled });
};

export const listAIConfigs = () => {
  const url = 'ai-config/list';
  return callApi(url, {}, 'GET');
};

export const createAIConfig = (body) => {
  const url = 'ai-config/';
  return callApi(url, {}, 'POST', body);
};

export const updateAIConfig = (configId, body) => {
  const url = `ai-config/${configId}`;
  return callApi(url, {}, 'PATCH', body);
};

export const deleteAIConfig = (projectIds) => {
  const url = 'ai-config/';
  return callApi(url, {}, 'DELETE', { projectIds });
};

export const toggleProjectAIConfig = (projectId, isEnabled) => {
  const url = `ai-config/projects/${projectId}/toggle`;
  return callApi(url, {}, 'PATCH', { isEnabled });
}

export const getProjectAIConfig = (projectId) => {
  const url = `ai-config/projects/${projectId}`;
  return callApi(url, {}, 'GET');
};

export const updateProjectAIConfig = (projectId, body) => {
  const url = `ai-config/projects/${projectId}`;
  return callApi(url, {}, 'PATCH', body);
};

export const getProjectAIAccess = (projectId, featureKey) => {
  const url = `ai-config/projects/${projectId}/ai-access?featureKey=${featureKey}`;
  return callApi(url, {}, 'GET');
};

export const getAIUsage = (projectId, period) => {
  const url = `ai-config/projects/${projectId}/usage?period=${period}`;
  return callApi(url, {}, 'GET');
};

export const getAiProviders  = () => {
  const url = 'ai-config/providers';
  return callApi(url, {}, 'GET');
};